export default {"src":"/_next/static/media/favicon.f453a8cf.svg","height":1080,"width":1080,"blurWidth":0,"blurHeight":0};